import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "swiper video-carousel" }
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "video-carousel__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "61",
  height: "61"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M30.637 60.221C14.114 60.221.672 46.78.672 30.256.672 13.731 14.114.29 30.637.29s29.966 13.441 29.966 29.966c0 16.524-13.443 29.965-29.966 29.965zm0-55.546c-14.105 0-25.58 11.474-25.58 25.581 0 14.106 11.475 25.58 25.58 25.58 14.105 0 25.58-11.474 25.58-25.58 0-14.107-11.475-25.581-25.58-25.581zm-1.085 35.773c-.956.396-2.048.773-3.073.773-.788 0-1.534-.222-2.145-.828-.474-.468-1.735-1.713-1.737-9.918-.002-8.667 1.307-9.961 1.737-10.386 1.534-1.51 4.021-.471 5.085-.028 1.518.633 12.181 6.101 12.181 10.195 0 3.816-9.595 9.167-12.048 10.192zm-2.177-16.516c-.518 2.92-.527 9.915-.008 12.693 2.565-.911 8.121-4.559 9.621-6.367-1.486-1.755-6.979-5.338-9.613-6.326z"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "video-carousel__video",
  controls: "controls",
  ref: "videoRef",
  autoplay: ""
}
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "swiper-slide",
            onClick: ($event: any) => (_ctx.play(index))
          }, [
            _createElementVNode("img", {
              src: video.thumbnail,
              alt: video.title
            }, null, 8, _hoisted_4),
            _hoisted_5
          ], 8, _hoisted_3))
        }), 128))
      ]),
      _hoisted_6
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modal) = $event)),
      onHide: _ctx.onHide,
      "no-header": "",
      "no-padding": ""
    }, {
      default: _withCtx(() => [
        (_ctx.selectedVideo)
          ? (_openBlock(), _createElementBlock("video", _hoisted_7, [
              _createElementVNode("source", {
                src: _ctx.selectedVideo.url,
                type: "video/mp4"
              }, null, 8, _hoisted_8)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHide"])
  ], 64))
}